import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import GamesHeader from 'components/GamesHeader/GamesHeader';
import { useSelector } from 'react-redux';
import useLocationChange from '../../helpers/useLocationChange';
import MyAccount from './MyAccount';
import SideNav from './SideNav';
import MyPoints from './MyPoints/MyPoints';
import ConnectWalletButton from '../ConnectWallet/ConnectWalletButton';
import { useMobileOnly } from '../../helpers/responsive';

import PeergameLogoLight from './assets/images/peergame-logo-light.svg?inline';
import PeergameLogoDark from './assets/images/peergame-logo-dark.svg?inline';
import IconRaces from './assets/images/races.svg?inline';
import IconSlots from '../../assets/img/slots.svg?inline';
import IconTableGames from '../../assets/img/table-games.svg?inline';
import IconGames from '../../assets/img/games.svg?inline';

import styles from './assets/styles.scss';

const cx = classNames.bind(styles);

export default function Header({ game, displaySubheader, classes }) {
  const isMobileOnly = useMobileOnly();
  const isLoggedIn = useSelector(state => !!state.auth.user);

  useLocationChange(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  });

  function gamesHeader() {
    return displaySubheader && game ? <GamesHeader /> : null;
  }
  return (
    <Fragment>
      <header className={cx(classes)}>
        <div className={cx('left')}>
          <SideNav reverse={!classes.includes('transparent')} />
          <Link to="/" className={cx('logo')}>
            {!classes.includes('transparent') && <PeergameLogoLight />}
            {classes.includes('transparent') && <PeergameLogoDark />}
          </Link>
        </div>
        <div className={cx('center')}>
          <Link to="/games" className={cx('header-button', { reverse: !classes.includes('transparent') })}>
            <IconGames />
            {!isMobileOnly && 'Games'}
          </Link>
          <Link
            to="/games?category=slots"
            className={cx('hide-mobile', 'header-button', { reverse: !classes.includes('transparent') })}
          >
            <IconSlots />
            Slots
          </Link>
          <Link
            to="/games?category=table"
            className={cx('hide-mobile', 'header-button', { reverse: !classes.includes('transparent') })}
          >
            <IconTableGames />
            Table Games
          </Link>
          <Link
            to="/races"
            className={cx('hide-mobile', 'header-button', { reverse: !classes.includes('transparent') })}
          >
            <IconRaces />
            Races
          </Link>
        </div>
        <div className={cx('right')}>
          {isLoggedIn && <MyPoints reverse={!classes.includes('transparent')} />}
          {isLoggedIn ? <MyAccount reverse={!classes.includes('transparent')} /> : <ConnectWalletButton />}
        </div>
      </header>
      {gamesHeader()}
    </Fragment>
  );
}
Header.propTypes = {
  game: PropTypes.string,
  displaySubheader: PropTypes.bool,
  classes: PropTypes.arrayOf(PropTypes.string),
};

Header.defaultProps = {
  game: null,
  displaySubheader: true,
  classes: [],
};
